document.addEventListener('DOMContentLoaded', () => {
    const textInput = document.getElementById('textInput');
    const wordCountEl = document.getElementById('wordCount');
    const charCountEl = document.getElementById('charCount');
    const iCountEl = document.getElementById('iCount');
    
    const statusBanner = document.getElementById('statusBanner');
    const iAlert = document.getElementById('iAlert');
    
    function analyzeText() {
        const text = textInput.value;
        
        // Character count
        const charCount = text.length;
        charCountEl.textContent = charCount;
        
        // Word count
        const words = text.trim() === '' ? [] : text.trim().split(/\s+/);
        const wordCount = words.length;
        wordCountEl.textContent = wordCount;
        
        // I / Me count
        const iPattern = /\b(i|me)\b/gi;
        const matches = text.match(iPattern);
        const iCount = matches ? matches.length : 0;
        iCountEl.textContent = iCount;
        
        if (text.trim() === '') {
            statusBanner.className = 'status-banner';
            statusBanner.textContent = 'Start typing to see length analysis.';
            statusBanner.style.display = 'block';
            iAlert.classList.remove('active');
            return;
        }
        
        // Length analysis
        if (wordCount < 200) {
            statusBanner.className = 'status-banner status-short';
            statusBanner.textContent = `Too Short: ${wordCount} words. Aim for at least 250 words to properly explain your fit.`;
        } else if (wordCount > 400) {
            statusBanner.className = 'status-banner status-long';
            statusBanner.textContent = `Too Long: ${wordCount} words. Recruiters may skim this. Try to cut it down below 400 words.`;
        } else {
            statusBanner.className = 'status-banner status-good';
            statusBanner.textContent = `Perfect Length: ${wordCount} words. You are right in the sweet spot (250-400 words).`;
        }
        
        // Alert if I/Me ratio is too high (e.g. > 4% of total words)
        if (wordCount > 50 && (iCount / wordCount) > 0.04) {
            iAlert.classList.add('active');
        } else {
            iAlert.classList.remove('active');
        }
    }

    textInput.addEventListener('input', analyzeText);
    
    // Initial analysis if there is pre-filled text
    analyzeText();
});
